















































































import _ from 'lodash'
import { Vue, Prop, Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class CheckoutDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private id!: string
  @Prop() private open!: boolean

  private isFinish = false

  get invalidateInput() {
    return _.some([], (item) => item !== true)
  }

  get openDialog() {
    return this.open
  }

  // tslint:disable-next-line:adjacent-overload-signatures
  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get createCheckoutDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.doCheckOut,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  private loading = false
  private valid = false
  private checkouts = [{ image: { file: '' }, text: '' }]
  private defaultLists = { image: { file: '' }, text: '' }

  @Action('schedule/putScheduleLogs')
  private putScheduleLogs!: (options) => void

  @Action('userprofile/getUserProfile')
  private getUserProfile!: (options: {}) => void

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }

  private doAddItem() {
    this.checkouts.push(_.clone(this.defaultLists))
  }

  private doDeleteItem(index) {
    this.checkouts = _.filter(this.checkouts, (item, itemIndex) => itemIndex !== index)
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  private async doCheckOut() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      const data = {
        id: this.id,
        logs: _.map(this.checkouts, (item) => {
          return {
            ...item,
            image: item.image.file,
          }
        }),
        status: this.isFinish ? 'สิ้นสุดการทำงาน' : 'กำลังทำงาน',
      }
      try {
        await this.putScheduleLogs(data)
        this.updateSnackbar({
          txt: this.isFinish ? 'สิ้นสุดการทำงานเรียบร้อยแล้ว' : 'ลงรายละเอียดการทำงานเรียบร้อยแล้ว',
          type: 'success',
        })
        this.loading = false
        this.getUserProfile({})
        this.closeDialog()
      } catch (error) {
        this.loading = false
      }

    }
  }
}
